module.exports = __webpack_public_path__ + "img/Y.09234d24.jpg";